import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Discount } from "@/types/discount";
import { newCustomerCleanup } from "../actions";
import { calculateCart } from "./async-thunk";
import { AgeCheck, ReceiptProduct } from "@/types/receipt";

interface CartState {
  products: ReceiptProduct[];
  discounts: Discount[];
  currentLegalAge: number | null;
  legalAgeQr: string | null;
  ageCheck: AgeCheck;
}

const getInitialState = (): CartState => ({
  products: [],
  discounts: [],
  currentLegalAge: null,
  legalAgeQr: null,
  ageCheck: {
    lineItems: [],
    requiredAge: null,
  },
});

export const cartSlice = createSlice({
  name: "cart",
  initialState: getInitialState(),
  reducers: {
    setAgeCheckQrCode: (state, { payload }: PayloadAction<string>) => {
      state.legalAgeQr = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(newCustomerCleanup, () => {
      return getInitialState();
    });
    builder.addCase(calculateCart.fulfilled, (state, action) => {
      state.products = action.payload.lineItems.products;
      state.discounts = action.payload.lineItems.discounts;
      state.ageCheck = action.payload.ageCheck;
      state.legalAgeQr = action.payload.legalAgeQr;
      state.currentLegalAge = action.payload.legalAge;
    });
  },
});

export const { setAgeCheckQrCode } = cartSlice.actions;

export default cartSlice.reducer;
